const pages = {
  ADDRESS_PAGE: "address",
  CONCLUSION_PAGE: "conclusion",
  CONTACT_PAGE: "contact",
  CULTURAL_BACKGROUND_PAGE: "cultural_background",
  HEALTH_AND_MEDICAL_PAGE: "health_and_medical",
  DIET_PAGE: "diet",
  GUEST_PACKAGES_PAGE: "guest_packages",
  GUEST_PREFERENCES_PAGE: "guest_preferences",
  GUEST_INTERACTION_LEVEL_PAGE: "guest_interaction_level",
  HOUSE_PAGE: "house",
  HOUSE_CONTINUED_PAGE: "house_continued",
  HOLDING_PAGE: "holding",
  INFO_PAGE: "info",
  INTERVAL_PAGE: "interval",
  PAYMENTS_PAGE: "payments",
  PETS_PAGE: "pets",
  PHOTO_PAGE: "photo",
  PROFILE_PAGE: "profile",
  REFERRAL_PAGE: "referral",
  REGISTER_PAGE: "register",
  RESIDENTS_PAGE: "residents",
  ROOMS_PAGE: "rooms",
  SMOKING_PAGE: "smoking",
  WITHDRAW_PAGE: "withdraw",
  PHONE_VERIFICATION_PAGE: "phone_verification",
  FAMILY_INTERESTS_PAGE: "family_interests",
  REFERENCES_PAGE: "references",
  FIREBASE_DETAILS_PAGE: "firebase_account_details",
  FIREBASE_REGISTER_PAGE: "firebase_register",
};

export default pages;
